import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { isSSR } from 'wix-rich-content-common';
import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { s as styles, C as CardContent } from '../CardContent-579ae7e1.js';
import 'wix-rich-content-common/libs/Tooltip';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getImageTargetHeight = (width, height, targetWidth) => {
  const proportion = height / width;
  const targetHeight = proportion * targetWidth;
  return targetHeight;
};
const Card = (props) => {
  const { url, content, direction, imageWidth, imageHeight, t, disabled } = props;
  const [imageSrc, setImageSrc] = useState();
  const getImageSrc = (targetWidth) => {
    const targetHeight = getImageTargetHeight(imageWidth, imageHeight, targetWidth);
    return getScaleImageSrc(props.imageSrc, targetWidth, targetHeight);
  };
  const setRef = (ref) => {
    var _a;
    if (ref) {
      const targetWidth = (_a = ref.getBoundingClientRect()) == null ? void 0 : _a.width;
      if (imageWidth && imageHeight) {
        const imageSrc2 = getImageSrc(targetWidth);
        setImageSrc(imageSrc2);
      } else {
        setImageSrc(props.imageSrc);
      }
    }
  };
  const imageUrl = isSSR() ? imageWidth && imageHeight ? getImageSrc(185) : props.imageSrc : imageSrc;
  const imageStyle = imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    /* @__PURE__ */ React.createElement("a", { className: styles.link, href: disabled ? null : url, target: "_blank", ref: setRef }, /* @__PURE__ */ React.createElement(
      "div",
      {
        style: { direction },
        className: classNames(styles[direction], styles.container, styles.cardLayout)
      },
      props.imageSrc && /* @__PURE__ */ React.createElement("div", { style: imageStyle, className: styles.image }),
      /* @__PURE__ */ React.createElement(CardContent, __spreadProps(__spreadValues({}, content), { disabled, t }))
    ))
  );
};
Card.propTypes = {
  imageSrc: PropTypes.string,
  content: PropTypes.object,
  direction: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  disabled: PropTypes.boolean,
  t: PropTypes.func.isRequired
};

export { Card as default };
//# sourceMappingURL=Card.js.map
